
/* routes */
export const routes = {
  TRANSCRIPT_VIEWER: '/',
  LOGIN: '/login',
}

/*  domain addresses */
export const domainAddresses = { };

export const FILE_TRANSFER_DOWNLOAD_ADDRESS = 'https://cw2c2b.providesupport.com';
